import { combineReducers } from "redux";

import DropDownListData from "./dropDownList/reducer";
import Participant from "./participants/reducer";
import Staff from "./staff/reducer";
import StaffByEmail from "./staffByEmail/reducer";
import ServiceList from "./services/reducer";
import SuperAdmin from "./superAdmin/reducer";
import vehicles from "./vehicle/reducer";
import StaffView from "./employeePortal/reducer";
import Register from "./register/reducer";
import RiskAssessment from "./riskAssessment/reducer";
import PrivacyPolicy from "./privacyPolicy/reducer";
import Layout from "./layout/reducer";
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import calendar from "./calendar/reducer";
import chat from "./chat/reducer";
import invoices from "./invoices/reducer";
import Dashboard from "./dashboard/reducer";
import training from "./training/reducer";
import shift from "./shift/reducer";
import mails from "./mails/reducer";
import fileManager from "./fileManager/reducer";
import ServiceRecord from "./serviceRecord/reducer";
import OpenShifts from "./openShift/reducer";
import NoticeBoard from "./noticeBoard/reducer";
import ChatGPT from "./chatGpt/reducer";
import Admins from "./admin/reducer";
import Medication from "./medication/reducer";
import Prescriber from "./prescriber/reducer";
import Template from "./template/reducer";
import Team from "./team/reducer";
import HazardReport from "./hazardReport/reducer";
import RoleAccess from "./roleAccess/reducer";
import ProgressNote from "./ProgressNote/reducer";
import Location from "./location/reducer";
import Integration from "./integration/reducer";
import ComplaintRegister from "./Complaints/reducer";
import ratingDashboard from "./ratingDashboard/reducer";
import FundingReport from "./fundingReport/reducer";

const rootReducer = combineReducers({
  FundingReport,
  ratingDashboard,
  ComplaintRegister,
  Integration,
  Location,
  ProgressNote,
  RoleAccess,
  HazardReport,
  Prescriber,
  Medication,
  Template,
  Admins,
  ChatGPT,
  NoticeBoard,
  OpenShifts,
  ServiceRecord,
  fileManager,
  mails,
  shift,
  PrivacyPolicy,
  training,
  vehicles,
  DropDownListData,
  Participant,
  Staff,
  ServiceList,
  Register,
  StaffByEmail,
  SuperAdmin,
  StaffView,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  chat,
  invoices,
  Dashboard,
  RiskAssessment,
  Team,
});

export default rootReducer;
